
<template>
  <div class="download-pc">
    <div class="download-box">
      <div class="download-info">
        <div class="download-info--left">
          <img src="@/assets/images/logo-app.png" alt="">
          <div class="download-info-info">
            <div>采道App</div>
            <div>
              <span>AI大数据</span>
              <span>模拟试玩</span>
              <span>走势图</span>
              <span>比分直播</span>
            </div>
          </div>
        </div>
        <div class="download-info--right">
          <img src="@/assets/images/ewm-download.png" alt="">
          <span>扫码下载</span>
        </div>
      </div>

      <!-- <div class="download-preview">
        <div class="download-preview-title">
          预览
        </div>

        <div class="download-preview-images">
          <img v-for="item in 4" :key="item" :src="require(`@/assets/images/preview-${item}.png`)"  alt="">
        </div>
      </div>

      <div class="download-introduce">
        <div class="download-introduce-title">
          简介
        </div>

        <div class="download-introduce-content">
          采道APP是嘉彩科讯开发的为彩票从业者和爱好者服务的一个互联网平台，初心就是在合法合规的情况下帮助彩票店主赚钱，增加彩票店主收益。采道平台以增加彩票店主收入，拓展彩票店主收入渠道为平台的方向发展。当然为彩票店主提供彩票店主帮扶项目、提供彩票店主日常运营所需的各类海报、视频、文案等资源，是采道平台最基本的工作。为彩票爱好者提供赛事资讯和数据服务。
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'download-pc'
}
</script>

<style lang="scss" scoped>
.download-pc {
  .download-box {
    @extend .container--pc;
    padding: 76px 0 242px;

    .download-info {
      margin-bottom: 80px;
      @include flex(row, space-between);

      .download-info--left {
        @include flex(row);
        img {
          width: 92px;
          height: 92px;
          margin-right: 20px;
        }

        .download-info-info {
          height: 92px;
          @include flex(col, center);

          div {
            &:nth-child(1) {
              margin-bottom: 20px;
              font-size: 32px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
              line-height: 38px;
            }

            &:nth-child(2) {
              span {
                margin-right: 8px;
                padding: 2px 12px;
                height: 24px;
                border-radius: 48px;
                text-align: center;
                font-size: 14px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                line-height: 16px;

                &:nth-child(1) {
                  background: rgba(23,105,228,0.08);
                  color: #1769E4;
                }

                &:nth-child(2) {
                  color: #FF4D00;
                  background: rgba(243,82,13,0.08);
                }

                &:nth-child(3) {
                  color: #62C812;
                  background: rgba(98,200,18,0.08);
                }

                &:nth-child(4) {
                  color: #1AD9F3;
                  background: rgba(26,217,243,0.08);
                }
              }
            }
          }
        }
      }

      .download-info--right {
        @include flex(col, center, center);
        img {
          margin-bottom: 10px;
          width: 110px;
          border: 1px solid #000;
          border-radius: 5px;
        }
        span {
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 16px;
        }
      }
    }

    .download-preview {
      margin-bottom: 69px;
      .download-preview-title {
        margin-bottom: 20px;
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
      }

      .download-preview-images {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        column-gap: 15px;

        img {
          width: 100%;
        }
      }
    }

    .download-introduce {
      .download-introduce-title {
        margin-bottom: 20px;
        font-size: 24px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
      }

      .download-introduce-content {
        font-size: 20px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
      }
    }
  }
}
</style>
